<template>
    <v-container  v-resize="onResize">
        <template>
            <v-card v-if="loading">
                <v-container fluid>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <div class="loader"></div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </template>        
        <v-layout row wrap v-show="!loading">
            <v-flex xs12 md6>
                <v-card-title>
                    <span v-if="ELECTORATE.length">

                        <h2 style="margin-bottom:12px" v-if="this.Electorate">
                            {{this.Electorate}}
                        </h2>
                        <p v-if="this.State">
                            State: {{this.State}}
                        </p>
                        <p v-if="ELECTORATE[0].Established">
                            {{STRING_COALESCE(formatDate(ELECTORATE[0].Established, 'Date Established: '))}}
                        </p>
                        <p v-if="ELECTORATE[0].Ceased">
                            {{STRING_COALESCE(formatDate(ELECTORATE[0].Ceased, 'Date Ceased: '))}}
                        </p>
                        <p v-if="ELECTORATE[0].Origin">
                            {{STRING_COALESCE(ELECTORATE[0].Origin,'Name Origin: ')}}
                        </p>
                        <p v-if="ELECTORATE[0].Notes"><span style="white-space:pre" v-html="STRING_COALESCE(ELECTORATE[0].Notes,'Notes: ')"/></p>                        
                    </span>
                </v-card-title>
            </v-flex>
            <v-flex xs12 offset-md2 md4 class="hidden-sm-and-down" >
                <v-text-field v-on:keyup="TRACK_SEARCH" v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
            </v-flex>
        </v-layout>

        <br/>
        
        <electorate-maps-selector :electorate="Electorate" :state="State"></electorate-maps-selector>
        
        <br/>
        <v-flex xs12 class="hidden-md-and-up" >
            <div>
                <v-text-field :class="{mobileTextField: isMobile}" v-on:keyup="TRACK_SEARCH" v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                <v-menu v-if="this.isMobile" d-inline offset-y :nudge-left="140" :close-on-content-click="true">
                    <v-btn outline small slot="activator">
                        Sort <v-icon>sort</v-icon>
                    </v-btn>
                    <v-list>
                        <v-subheader>Sort by:</v-subheader>
                        <v-list-tile v-for="(item, index) in HEADERS.filter(h => h.text != '' && h.sortable != false)" :key="item.value" @click="changeSort(item.value)">
                            <v-list-tile-title>
                                {{ item.text }}
                                <v-icon v-if="PAGINATION.sortBy === item.value">{{PAGINATION.descending ? 'arrow_downward':'arrow_upward'}}</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </div>
              <br/>
        </v-flex>
        <v-data-table :items="PARLIAMENTARIANS"
                      :headers="HEADERS"
                      :rows-per-page-items="ROWS_LISTITEMS"
                      :pagination.sync="PAGINATION"
                      v-on:update:pagination="UPDATE_PAGINATION"
                      :search="search"
                      :hide-headers="isMobile"
                      :class="{ mobileDataTable: isMobile, 'elevation-1': true }"
                      v-show="!loadingParliamentarians">
            <template v-slot:items="props">
                <tr v-if="isMobile">
                    <td>
                        <div class="flex-content pt-2">
                            <div class="flex-item">
                                <router-link :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.PHID }}">
                                    <h3 class="pb-xs-0">{{ props.item.DisplayName }}</h3>
                                </router-link>
                            </div>
                            <div class="flex-item flex-item-col flex-item-col-30">
                                <div class="flex-item">
                                    <Portrait v-bind:PHID="props.item.PHID" :fixedWidth="80"></Portrait>
                                </div>
                            </div>
                            <div class="flex-item flex-item-col flex-item-col-70">
                                <div class="flex-item" data-label="Party">
                                    <span v-for="(party, index) in props.item.Party" :key="party.ValueID" >
                                        <span v-if="index > 0">, </span><a @click="handlePartyClick(party.ValueID)">{{ party.Value }}</a>
                                    </span>
                                </div>
                                <div class="flex-item flex-item-col" data-label="Served from">{{ props.item.ElectorateServiceStart | stringDateFormat}}</div>
                                <div class="flex-item flex-item-col" data-label="Served to">
                                    <span v-if="props.item.ElectorateServiceEnd">{{ props.item.ElectorateServiceEnd | stringDateFormat }}</span>
                                    <span v-if="!props.item.ElectorateServiceEnd">N/A</span>
                                </div>
                                <div class="flex-item" data-label="Elected">
                                    <span v-for="(service, index) in filterElectorateService(props
                                        .item
                                        .ElectorateService)" 
                                        :key="service.ServiceStart">
                                        <a tabindex="0" v-on:keyup.enter="clickElected(service.ServiceStart)" @click="clickElected(service.ServiceStart)">
                                            {{service.ServiceStart | truncate(0, 4)}}<span v-if="index + 1 !== filterElectorateService(props.item.ElectorateService).length">,</span>
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr v-else>
                    <td class="text-xs-left"><Portrait v-bind:PHID="props.item.PHID" :fixedWidth="80"></Portrait></td>
                    <td class="text-xs-left">
                        <router-link :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.PHID }}">
                            {{ props.item.DisplayName }}
                        </router-link>
                    </td>
                    <td class="text-xs-left">
                        <!-- <span v-for="(party, index) in props.item.Party" :key="party.ValueID" >
                            <span v-if="index > 0">, </span><a @click="handlePartyClick(party.ValueID)">{{ party.Value }}</a>
                        </span> -->
                        <span v-for="(party, index) in props.item.Party" :key="party.ValueID" >
                            <span v-if="index > 0">, </span>
                            <router-link 
                                :to="{ name: $store.state.ROUTE_PARTY, params: { Party: party.ValueID }}">
                                {{party.Value}}</router-link>
                        </span>
                        
                    </td>
                    <td class="text-xs-right">{{ props.item.ElectorateServiceStart | stringDateFormat}}</td>
                    <td class="text-xs-right">{{ props.item.ElectorateServiceEnd | stringDateFormat}}</td>
                    <td class="text-xs-right">
                        <div v-for="service in filterElectorateService(props
                            .item
                            .ElectorateService)" 
                            :key="service.ServiceStart">
                            <a tabindex="0" v-on:keyup.enter="clickElected(service.ServiceStart)" @click="clickElected(service.ServiceStart)">
                                {{ service.ServiceStart | truncate(0, 4) }}
                            </a>
                        </div>
                    </td>
                </tr>
            </template>

            <template v-slot:no-results>
                <v-alert :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                </v-alert>
            </template>
        </v-data-table>

        <v-layout row wrap v-show="!loading">
            <v-flex xs12>
                <div style="float:right">
                    <v-btn v-on:keyup.enter="EXPORT_ELECTORATE_PDF" v-on:click="EXPORT_ELECTORATE_PDF" color="primary">
                        <v-icon aria-hidden="true" :class="pdfDownloadClass">{{pdfDownloadIcon}}</v-icon>
                        <span >&nbsp;Download as PDF</span>
                    </v-btn>
                    <v-btn v-on:keyup.enter="EXPORT_ELECTORATE_CSV" v-on:click="EXPORT_ELECTORATE_CSV" color="primary">
                        <v-icon aria-hidden="true" :class="csvDownloadClass">{{csvDownloadIcon}}</v-icon>
                        <span >&nbsp;Download as CSV</span>
                    </v-btn>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>


<script>
    window.scrollTo(0, 0);
    import Portrait from '@/components/Portrait.vue'
    import ElectorateMapsSelector from './ElectorateMapsSelector.vue'
    import axios from 'axios'
    import moment from 'moment'

    export default {

        components: {
            Portrait,
            ElectorateMapsSelector
        },

        props: {
            Electorate: {
                type: String,
                required: true,
            },
            State: {
                type: String,
                required: true,
            },
        },

        data() {
            return {
                isMobile: false,
                search: '',
                loading: true,
                loadingParliamentarians: true,
                pdfDownloading: false,
                csvDownloading: false,
                ELECTORATE: [],
                PARLIAMENTARIANS: [],
                ROWS_LISTITEMS: [5, 10, 50, {
                    "text": "$vuetify.dataIterator.rowsPerPageAll",
                    "value": -1
                }],

                PAGINATION: {
                    sortBy: 'ElectorateServiceStart',
                    descending: true,
                    rowsPerPage: this.$store.state.ROWS_PER_PAGE
                },

                HEADERS: [
                    {
                        text: '',
                        value: 'DisplayName',
                        align: 'left',
                        sortable: false,
                    },
                    {
                        text: 'Name',
                        value: 'DisplayName',
                        align: 'left',
                        sortable: true,
                    },
                    {
                        text: 'Party',
                        value: 'Party',
                        align: 'left',
                        sortable: false,

                    },
                    {
                        text: 'Served from',
                        value: 'ElectorateServiceStart',
                        align: 'right',
                        sortable: true,
                        sort: (a, b) => this.$moment(a) > this.$moment(b),

                    },
                    {
                        text: 'Served to',
                        value: 'ElectorateServiceEnd',
                        align: 'right',
                        sortable: true,
                        sort: (a, b) => this.$moment(a) > this.$moment(b)
                    },
                    {
                        text: 'Elected',
                        value: '',
                        align: 'right',
                        sortable: false,
                    }
                ],
            }
        },
        created() {
            this.loadElectorate();
            this.loadParliamentarians();
        },
        mounted() {
            this.onResize();
            //Set page to 10 on mobile, only on mount
            if (this.isMobile){
                this.PAGINATION.rowsPerPage = 10;
            }
        },
        methods: {
            onResize() {
                if (window.innerWidth < 769){
                    this.isMobile = true;
                }
                else{
                    this.isMobile = false;
                }
            },
            changeSort(column) {
                if (this.PAGINATION.sortBy === column) {
                    this.PAGINATION.descending = !this.PAGINATION.descending
                } 
                else {
                    this.PAGINATION.sortBy = column
                    this.PAGINATION.descending = false
                }
            },
            loadElectorate() {
                this.loading = true;
                const url = `electorates?$select=Electorate,State,Established,Ceased,Origin,Notes&$filter=Electorate eq '${this.electorateOdata}' and State eq '${this.State}'`;
                axios.get(`api/${url}`)
                    .then(response => {
                        this.ELECTORATE = response.data.value;
                        this.loading = false;
                        if (this.ELECTORATE != null){
                            window.document.title = this.Electorate;   
                        }
                    });
            },
            filterElectorateService(electorateService) {
                return electorateService.filter(e => e.Electorate === this.Electorate);
            },
            clickElected(dateElected) {
                // need to call API
                // const { memberOrSenator, electorate, x } = this.point.options;
                // const date = moment(dateElected).format('YYYY-M-D');
                const year = new Date(dateElected).getFullYear();
                const url = `Elections/ElectionId?date=${dateElected}`;
                const electorate = this.Electorate;
                axios.get(`api/${url}`)
                    .then(response => {
                        this.$router.push({ name: 'DivisionalResult', params: { year, electionId: response.data, division: electorate }});
                    });
            },
            loadParliamentarians() {
                this.loadingParliamentarians = true;
                const url = `individuals?$select=PHID,DisplayName,MPorSenator,Gender,State,StateAbbrev,Electorate,Party,PartyParliamentaryService,ElectorateService,RepresentedElectorates,RepresentedParties&$filter=ElectorateService/any(e:e/Electorate%20eq%20'${this.electorateOdata}' and e/State eq '${this.State}')`;
                axios.get(`api/${url}`)
                    .then(response => {
                        const parliamentarians = response.data.value;
                        var services = [];
                        // pull out all the 'electorate services' and map their start and finish dates properly
                        for (var i = 0; i < parliamentarians.length; i++) {
                            var electorateServices = parliamentarians[i].ElectorateService.filter(es => es.Electorate === this.Electorate);
                            for (var j = 0; j < electorateServices.length; j++) {
                                var serviceEnd = electorateServices[j].ServiceEnd === "1900-01-01" ? moment(new Date()).format('yyyy-MM-DD') : electorateServices[j].ServiceEnd;
                                var parlService = { ...parliamentarians[i], ElectorateServiceStart: electorateServices[j].ServiceStart, ElectorateServiceEnd: serviceEnd }
                                services.push(parlService);
                            }
                        }

                        // Need to sort to determine consecutive services
                        services.sort((a, b) => moment(a.ElectorateServiceStart) === moment(b.ElectorateServiceStart) ? 0 : moment(a.ElectorateServiceStart) < moment(b.ElectorateServiceStart) ? -1 : 1);

                        var consolidatedServices = [];
                        var first = undefined;
                        var parties = [];
                        // now group the service records by parliamentarian where the service records are consecutive 
                        for (var k = 0; k < services.length; k++) {
                          
                            if (!first) {
                                first = services[k];
                                let parlServices = services[k].PartyParliamentaryService.find(pps => pps.DateStart === services[k].ElectorateServiceStart && pps.DateEnd === services[k].ElectorateServiceEnd);
                              
                                if (parlServices && parlServices.SecondaryService){
                                    parlServices.SecondaryService.forEach(function (pr) {
                                        if (!parties.some(p => p.Value === pr.Value)) {
                                            parties.push(pr);
                                        }
                                    });
                                }
                            } else {
                                if (first.PHID !== services[k].PHID) {
                                    var svcMid = { ...first, ElectorateServiceEnd: services[k - 1].ElectorateServiceEnd, Party: parties };

                                    //remove unneeded properties so it doesn't show up on the CSV
                                    // delete svcMid.ElectorateService;
                                    consolidatedServices.push(svcMid);
                                    first = services[k];
                                    parties = [];
                                }
                                
                                let parlServices = services[k].PartyParliamentaryService.find(pps => pps.DateStart === services[k].ElectorateServiceStart && pps.DateEnd === services[k].ElectorateServiceEnd);
                                if (parlServices && parlServices.SecondaryService) {
                                    parlServices.SecondaryService.forEach(function (pr) {
                                        if (!parties.some(p => p.Value === pr.Value)) {
                                            parties.push(pr);
                                        }
                                    });
                                }

                            }

                            // add to the array if it's the last record and remove unneeded properties so it doesn't show up on the CSV
                            if (k === services.length - 1) {
                                var svcEnd = { ...first, ElectorateServiceEnd: services[k].ElectorateServiceEnd, Party: parties };
                                // delete svcEnd.ElectorateService;
                                consolidatedServices.push(svcEnd);
                            }
                        }
                
                        //catch all in case the party value is empty somehow
                        for (let i = 0; i < consolidatedServices.length; i++) {
                            if (!consolidatedServices[i].Party && consolidatedServices[i].RepresentedParties && consolidatedServices[i].RepresentedParties.length > 0) {
                                consolidatedServices[i].Party = { Value: consolidatedServices[i].RepresentedParties[0]};
                            }

                            let today = moment().format('YYYY-MM-DD');
                            if (today === moment(consolidatedServices[i].ElectorateServiceEnd).format('YYYY-MM-DD')) {
                                consolidatedServices[i].ElectorateServiceEnd = '';
                            }
                        }
                        this.PARLIAMENTARIANS = consolidatedServices;
                        this.loadingParliamentarians = false;
                    });
            },
            EXPORT_ELECTORATE_CSV: function () {
                this.$gtag.event(`electorate ${this.Electorate} download csv`, {
                    'event_category': 'downloads',
                    'event_label': `electorate ${this.Electorate} csv download`,
                    'value': 1
                });

                this.csvDownloading = true;

                let thisElectorate = this.PARLIAMENTARIANS;
                let OBJ_records = [];
                let headers = ['Name', 'PHID', 'Party', 'Start Date', 'End Date'];
                let filename = `${this.Electorate}, ${this.State}`
                let index = 0;

                //  then we progressively build up the  exportOBJ
                for (index = 0; index < thisElectorate.length; ++index) {

                    OBJ_records.push({
                        'Name': thisElectorate[index].DisplayName,
                        'PHID': thisElectorate[index].PHID,
                        'Party': thisElectorate[index].Party.map(p => p.Value).join(', '),
                        'Start Date': this.formatDate(thisElectorate[index].ElectorateServiceStart, '', 'YYYY-MM-DD', false),
                        'End Date': this.formatDate(thisElectorate[index].ElectorateServiceEnd, '', 'YYYY-MM-DD', false)
                    });
                }
                this.$store.dispatch('GETCSV', { DATA: OBJ_records, HEADERS: headers, FILENAME: filename })
                    .catch(this.showError)
                    .finally(() => this.csvDownloading = false);
                thisElectorate = null;
                OBJ_records = null;
                index = null;
            },
            EXPORT_ELECTORATE_PDF: function () {
                this.$gtag.event(`electorate ${this.Electorate} download pdf`, {
                    'event_category': 'downloads',
                    'event_label': `electorate ${this.Electorate} pdf download`,
                    'value': 1
                });

                this.pdfDownloading = true;

                let url = `${this.$store.state.URL_API}/document/electorate`;
                let electorateModel = { Electorate: this.ELECTORATE[0], Members: [] }
                for (let i = 0; i < this.PARLIAMENTARIANS.length; i++) {

                    electorateModel.Members.push({
                        'DisplayName': this.PARLIAMENTARIANS[i].DisplayName,
                        'PHID': this.PARLIAMENTARIANS[i].PHID,
                        'Party': this.PARLIAMENTARIANS[i].Party.map(p => p.Value).join(', '),
                        'ElectorateServiceStart': this.PARLIAMENTARIANS[i].ElectorateServiceStart ? this.$moment(this.PARLIAMENTARIANS[i].ElectorateServiceStart).format('DD.MM.YYYY') : "",
                        'ElectorateServiceEnd': this.PARLIAMENTARIANS[i].ElectorateServiceEnd ? this.$moment(this.PARLIAMENTARIANS[i].ElectorateServiceEnd).format('DD.MM.YYYY') : "",
                    });
                }

                electorateModel.Electorate.Established = this.$moment(electorateModel.Electorate.Established).format('DD.MM.YYYY');
                if (electorateModel.Electorate.Ceased) {
                    electorateModel.Electorate.Ceased = this.$moment(electorateModel.Electorate.Ceased).format('DD.MM.YYYY');
                }

                axios.post(url, electorateModel, { responseType: 'arraybuffer' })
                    .then((response) => {
                        let blob = new Blob([response.data], { type: 'application/pdf' }),
                            downloadUrl = window.URL.createObjectURL(blob),
                            filename = `Electorate [${this.Electorate}].pdf`

                        let a = document.createElement("a");
                        if (typeof a.download === "undefined") {
                            window.location.href = downloadUrl;
                        } else {
                            a.href = downloadUrl;
                            a.download = filename;
                            document.body.appendChild(a);
                            a.click();
                        }
                        a.remove();
                    }).catch(this.showError)
                    .finally(() => this.pdfDownloading = false);
            },

            UPDATE_PAGINATION: function (options) {
                this.$gtag.event(`electorate ${this.Electorate} pagination items per page`, {
                    'event_category': 'filters',
                    'event_label': `items per page: ${options.rowsPerPage}`,
                    'value': 1
                });
                this.$gtag.event(`electorate ${this.Electorate} pagination page`, {
                    'event_category': 'filters',
                    'event_label': `page: ${options.page}`,
                    'value': 1
                });
            },

            TRACK_SEARCH: function () {
                if (this.search.length >= 3) {
                    this.$gtag.event('electorate - search', {
                        'event_category': 'filters',
                        'event_label': this.search,
                        'value': 1
                    });
                }
            },

            STRING_COALESCE(STRING, PREFIX) {
                if (!PREFIX)
                    PREFIX = ''
                if (STRING && STRING != 'undefined' && STRING != 'Undefined' && STRING.trim() != '') {
                    STRING = PREFIX + STRING.trim() + ' '
                } else {
                    STRING = ''
                }
                return STRING
            }
        },
        computed: {
            electorateOdata() {
                return this.Electorate.replace("'", "''");
            },
            pdfDownloadIcon(){
                return this.pdfDownloading ? 'cached' : 'picture_as_pdf';
            },
            pdfDownloadClass(){
                let pdfClass = 'mr-1';
                if (this.pdfDownloading){
                    pdfClass = pdfClass + ' loading'
                }
                return pdfClass;
            },
            csvDownloadIcon(){
                return this.csvDownloading ? 'cached' : 'text_snippet';
            },
            csvDownloadClass(){
                let csvClass = 'mr-1';
                if (this.csvDownloading){
                    csvClass = csvClass + ' loading'
                }
                return csvClass;
            }        
        }
    }
</script>
<style scoped>
    td.handbook-tablecol_linebreaks {
        white-space: pre;
    }

    .v-datatable .tr {
        display:table-row;
    }

    .v-datatable a.tr {
        text-decoration:none;
    }
    .v-datatable a:hover.tr {
        text-decoration: underline;
    }

    .v-datatable tbody td {
        vertical-align: middle;
    }

</style>
